"use strict";
// Security-Sensitive Functionality is in the functions directory, but interfaces for frontend-backend messages are provided here.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PERMISSIONS = void 0;
exports.DEFAULT_PERMISSIONS = {
    isAdmin: false,
    hasSubscription: false,
    hasTestSubscription: false,
};
